import { useState } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCertificate } from "@fortawesome/free-solid-svg-icons";
import './CertificateSlider.css';
import { ChevronLeft, ChevronRight, X } from 'lucide-react';
import pic1 from "../assets/cbse.png";
import pic2 from "../assets/camb.webp";

export default function RecruitersAwards() {
  const [currentCert, setCurrentCert] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const certificates = [
    {
      id: 1,
      title: 'CBSE Affiliated',
      subtitle: 'Central Board of Secondary Education',
      certImage: pic1,
      content: `At Bihani Children's Academy, we are proud to be affiliated with the Central Board of Secondary Education (CBSE), one of India's most prestigious and widely recognized educational boards.

Our CBSE affiliation ensures that our students receive education aligned with national standards while maintaining our commitment to holistic development and excellence. The curriculum is designed to build strong foundational knowledge in all subjects while encouraging critical thinking and creativity.

With CBSE affiliation, our students have access to well-structured curricula, standardized assessments, and seamless transition to higher education institutions across India and abroad. We blend academic rigor with co-curricular activities to develop well-rounded individuals.

Join us as we nurture young minds with quality education, strong values, and a vision for a brighter future!`
    },
    {
      id: 2,
      title: 'Cambridge International',
      subtitle: 'International School',
      certImage: pic2,
      content: `Bihani Children's Academy has registered as a Cambridge International School, opening doors to world-class education recognized globally.

Cambridge International School status represents our commitment to excellence in education, providing students with access to rigorous academic programs and internationally acclaimed qualifications.

Our affiliation with Cambridge ensures that our students receive education that meets international standards, preparing them to excel in universities worldwide and become confident, capable global citizens.

Join us as we continue to foster excellence, innovation, and a passion for lifelong learning!`
    }
  ];

  const nextCert = () => {
    setCurrentCert((prev) => (prev + 1) % certificates.length);
  };

  const prevCert = () => {
    setCurrentCert((prev) => (prev - 1 + certificates.length) % certificates.length);
  };

  const openModal = () => {
    setIsModalOpen(true);
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    setIsModalOpen(false);
    document.body.style.overflow = 'auto';
  };

  const handleOverlayClick = (e) => {
    if (e.target.classList.contains('modal-overlay')) {
      closeModal();
    }
  };

  return (
    <div className="awards-main-container">
      <h2 className="section-header">CERTIFICATIONS</h2>
      
      <div className="award-icon-section">
        <FontAwesomeIcon icon={faCertificate} className='medal-icon'/>
      </div>
      
      <div className="awards-content">
        {/* Left Side - Image Slider */}
        <div className="cert-slider-section">
          <button className="carousel-btn prev-btn" onClick={prevCert}>
            <ChevronLeft size={40} />
          </button>

          <div 
            className="cert-image-container"
            onClick={openModal}
            title="Click to view full certificate"
          >
            <img 
              src={certificates[currentCert].certImage} 
              alt={certificates[currentCert].title}
              className="cert-image"
            />
          </div>

          <button className="carousel-btn next-btn" onClick={nextCert}>
            <ChevronRight size={40} />
          </button>
        </div>

        {/* Right Side - Content */}
        <div className="cert-content-section">
          <div className="content-wrapper">
            <h3 className="content-title">{certificates[currentCert].title}</h3>
            <p className="content-text">{certificates[currentCert].content}</p>
          </div>
        </div>
      </div>

      {/* Image Modal */}
      <div 
        className={`modal-overlay ${isModalOpen ? 'active' : ''}`}
        onClick={handleOverlayClick}
      >
        <div className="image-modal-content">
          <button 
            className="modal-close-btn"
            onClick={closeModal}
            aria-label="Close"
          >
            <X size={32} />
          </button>

          <img 
            src={certificates[currentCert].certImage}
            alt={certificates[currentCert].title}
            className="fullscreen-image"
          />
        </div>
      </div>
    </div>
  );
}